// extracted by mini-css-extract-plugin
export default {"activityList":"ActivityList_activityList__GwBvq"};